import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidFlashCounting } from '../../../../mechanics/rid-flash-counting/rid-flash-counting';

@Component({
  selector: 'app-flash-counting-page',
  imports: [RidFlashCounting],
  templateUrl: './flash-counting-categorized-page.html',
})
export class FlashCountingCategorizedPage {
  protected readonly $router = inject(Router);
  protected readonly numbers = computed(() =>
    Array(5)
      .fill(0)
      .map(() => Math.floor(Math.random() * 6) + 3),
  );
}
